import { render, staticRenderFns } from "./NavigableTocItem.vue?vue&type=template&id=33612645&lang=pug&"
import script from "./NavigableTocItem.vue?vue&type=script&lang=js&"
export * from "./NavigableTocItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports